import { Paper, Button } from "@mui/material";
import {useOutletContext} from "react-router-dom";
import { DataGrid,GridToolbarContainer,GridToolbarFilterButton, GridToolbarQuickFilter} from '@mui/x-data-grid';
import NewProjectDialog from "../../components/NewProjectDialog";
import { useState } from "react";
import { Project } from "../../features/db/project";
import ReAuthDeleteDialog from "../../components/ReAuthDeleteDialog";

export default function ProjectsPage() {
	const {projectsContainer} = useOutletContext();
	const [projects, setProjects] = projectsContainer;

	const [selectionModel, setSelectionModel] = useState([]);

	const columns = [
		{ field: 'name', headerName: 'Project', flex:1},
		{ field: 'year', headerName: 'Year', flex:0.4},
		{ field: 'status', headerName: 'Status', flex:0.4, type: 'boolean'},
	];

	const submitCallback = (p)=>
	{
		setProjects([...projects, p]);
	}

	const handleDelete = ()=>
	{
		if(selectionModel.length > 0)
		{
			Project.deleteAndUpdate(selectionModel,projects,setProjects);
		}
	}

	const handleToggleStatus = ()=>
	{
		if(selectionModel.length > 0)
		{
			let temp = projects.map(project => {
				const key = project.id;
				if(selectionModel.includes(key))
				{
					project.status = !project.status;
					Project.submitUpdateProject(project);
				}
				return project;
			});
			setProjects(temp);
		}
	}

	const CustomToolbar = ({ setFilterButtonEl }) => (
		<GridToolbarContainer sx = {{m:1}}>
			<GridToolbarQuickFilter />
			<GridToolbarFilterButton ref={setFilterButtonEl} />
			<NewProjectDialog submitCallback={submitCallback}/>
			<Button onClick={handleToggleStatus}>Toggle Status</Button>
			<ReAuthDeleteDialog handleDelete = {handleDelete} selectionSize = {selectionModel.length}/>
		</GridToolbarContainer>
	);

	return (
		<Paper varient="outlined" sx={{m:2}} elevation={10}>
			<DataGrid
				autoHeight
				rows={projects}
				columns={columns}
				checkboxSelection
				components={{Toolbar: CustomToolbar }}
				disableColumnSelector
				disableDensitySelector
				onSelectionModelChange = {(newSelectionModel) => {
					setSelectionModel(newSelectionModel);
				}}
				selectionModel={selectionModel}
				getRowHeight={() => 'auto'}
			/>
		</Paper>
	);
}